'use strict';
const angular = require('angular');

export class violationShowComponent {
  /*@ngInject*/
  constructor(dialogs, CalendarEventService, $timeout) {
    this.dialogs = dialogs;
    this.CalendarEventService = CalendarEventService;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.violation = this.resolve.config.violation;
    this.level = this.resolve.config.level;

    this.levelDate = new Date(this.resolve.config.levelDate);
    this.userHasPermission = this.resolve.config.userHasPermission;

    this.galleryImages = this.violation.attachments.filter(attachment => {
      return this.isImageMime(attachment.contentType);
    });

    this.galleryImages = this.galleryImages.map(function(obj){
      var rObj = {};

      rObj.title = obj.filename;
      rObj.alt = obj.filename;
      rObj.url = "/api/storage/" + obj._id;
      rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';

      return rObj;
    });
  }

  countPdfAttachments(attachs) {
    return attachs.reduce((acc, obj) => {
      return acc + this.isPdfMime(obj.contentType);
    }, 0);
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  ok() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduuApp.violationShow', [])
  .component('violationShow', {
    template: require('./violation-show.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: violationShowComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/violation-show/violation-show.component.js